import landingLogo from "../../../assets/landing-logo.svg";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";
import { useState } from "react";
import "./style.css";

function Header({ data }) {
	const [open, setOpen] = useState(false);
	const { t } = useTranslation();
	const navigate = useNavigate();
	const lang = useSelector((state) => state.lang.lang);

	const closeNavbar = () => {
		const navbar = document.querySelector(".navbar-collapse");
		if (navbar.classList.contains("show")) {
			// new window.bootstrap.Collapse(navbar).hide(); // requires Bootstrap JS
			navbar.classList.remove("show");
		}
		setOpen(false);
	};

	return (
		<div className="landing-header">
			<div className="position-relative">
				<div className="landing-navbar">
					<div className="landing-logo">
						<motion.img
							src={landingLogo}
							initial={{ opacity: 0, x: -50 }}
							animate={{ opacity: 1, x: 0 }}
							transition={{ duration: 1 }}
							alt="landinglogo"
						/>
					</div>
					<motion.div
						initial={{ opacity: 0, x: 50 }}
						animate={{ opacity: 1, x: 0 }}
						transition={{ duration: 1 }}
						className="landing-links">
						<button
							className={`navbar-toggler hamburger ${open ? "open" : ""}`}
							type="button"
							onClick={() => setOpen((prev) => !prev)}
							data-bs-toggle="collapse"
							data-bs-target="#navbarNavAltMarkup"
							aria-controls="navbarNavAltMarkup"
							aria-expanded="false"
							aria-label="Toggle navigation">
							<span></span>
							<span></span>
							<span></span>
						</button>
						<div
							className="collapse navbar-collapse"
							style={{ width: "fit-content" }}
							id="navbarNavAltMarkup">
							<Link onClick={closeNavbar} to="/">
								{t("home")}
							</Link>
							<Link onClick={closeNavbar} to="/our-products">
								{t("Our products")}
							</Link>
							<Link onClick={closeNavbar} to="/about-us">
								{t("about-us")}
							</Link>
						</div>
					</motion.div>
				</div>
				{data?.map((item, index) => {
					return (
						<div key={index} className="header">
							<img className="d-block w-100" src={item?.image} alt="slide" />
						</div>
					);
				})}
				{!!data?.length && (
					<div className="header-title">
						{(data[0].title_en || data[0].title_ar) && (
							<motion.p
								initial={{ opacity: 0 }}
								animate={{ opacity: 1 }}
								transition={{ delay: 0.25, duration: 1 }}>
								{lang === "en" ? data[0].title_en : data[0].title_ar}
							</motion.p>
						)}
					</div>
				)}
				<motion.button
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					transition={{ delay: 0.25, duration: 1 }}
					className="shop-now"
					onClick={() => navigate("/our-products")}>
					{t("Shop Now")}
				</motion.button>
			</div>
		</div>
	);
}

export default Header;
